import Box from "@mui/material/Box";

interface IProps {
  children: React.ReactElement;
}

export default function Container({ children }: IProps) {
  return <Box sx={{ pt: { xs: "140px", md: "180px" }, pb: 4 }}>{children}</Box>;
}
